var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.347,
    height: 18.456,
    viewBox: "0 0 18.347 18.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_73c0482f37cd99b2b06cd7d3eba8c43e",
    "data-name": "73c0482f37cd99b2b06cd7d3eba8c43e",
    d: "M15.456,13.058c-.184-.092-1.382-.645-1.567-.737a.434.434,0,0,0-.553.092c-.184.184-.553.737-.737.922-.092.184-.276.184-.461.092a7.535,7.535,0,0,1-1.843-1.106A10.609,10.609,0,0,1,9,10.754a.405.405,0,0,1,.092-.461c.092-.092.184-.276.369-.369a.7.7,0,0,0,.184-.369.28.28,0,0,0,0-.369,16.383,16.383,0,0,1-.737-1.659c-.092-.645-.276-.645-.461-.645H7.991a1.051,1.051,0,0,0-.553.276,2.653,2.653,0,0,0-.829,1.935,4.828,4.828,0,0,0,.922,2.4A9.826,9.826,0,0,0,11.4,14.9a7.224,7.224,0,0,0,1.29.461,2.632,2.632,0,0,0,1.475.092,2.388,2.388,0,0,0,1.567-1.106,1.541,1.541,0,0,0,.092-1.106l-.369-.184m2.3-8.387A9.187,9.187,0,0,0,3.29,15.731L2,20.431l4.885-1.29a9.106,9.106,0,0,0,13.456-8.018A8.977,8.977,0,0,0,17.76,4.671m-2.488,12.9a7.735,7.735,0,0,1-4.055,1.2,8.082,8.082,0,0,1-3.871-1.014l-.276-.184-2.857.737.737-2.765-.184-.276a7.739,7.739,0,0,1,2.488-10.6,7.5,7.5,0,0,1,10.415,2.4,7.605,7.605,0,0,1-2.4,10.507",
    transform: "translate(-2 -1.975)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7b0e5759aea4bfa40ec8ea46a7e44e58.svg";
export { ForwardRef as ReactComponent };